/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-7-7
 * Time: 15:20
 * Desc:
 */

import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class ClassGoods extends Vue {
  @Prop({ default: [] }) labelList: ItemArray<ComponentsInfo>;
  @Prop({ default: 0 }) pageIndex: number;
  @Prop({ default: 0 }) chooseIndex: number;

  public labels: ItemArray<ComponentsInfo> = [];

  public created() {
    console.log('ClassGoods Created');
    this.labels = this.labelList;
  }

  @Watch('labelList', { deep: true })
  watchLabelList() {
    this.labels = this.labelList;
  }
}
